<template>
  <div  class="chartheight" ref="chart"></div>
</template>

<script>
export default {
  props: {
    fans: null,
  },
  data() {
    return {
      myCharts: null,
      chartData: [
        {
          value: this.fans.followedCount,
          name: "店铺粉丝",
          itemStyle: { color: "#4878FF" },
        },
        {
          value: this.fans.notFollowedCount,
          name: "非店铺粉丝",
          itemStyle: { color: "#36CBCB" },
        },
      ],
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
      window.addEventListener("resize", () => {
        this.myCharts.resize();
      });
    });
  },
  methods: {
    initChart() {
      this.myCharts = this.$echarts.init(this.$refs.chart);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      let options = {
        // 提示框组件
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} 人 ({d}%)",
        },
        legend: {
          bottom: 10,
          icon: "circle",
          data: ["店铺粉丝", "非店铺粉丝"],
          itemWidth: 8,
          itemHeight: 8,
        },
        // 系列列表。每个系列通过 type 决定自己的图表类型
        series: {
          name: "是否为粉丝",
          type: "pie",
          radius: ["50%", "65%"],
          avoidLabelOverlap: true,
          label: {
            show: true,
              formatter: '{b}: {@2012} \n ({d}%)',
              color:"#333",
              width: 20,
              position: 'outer',
              alignTo: 'edge',
              margin: 10
            // position: 'center'
          },
          emphasis: {
            label: {
              show: true,
              fontSize: "16",
              fontWeight: "bold",
            },
          },
          labelLine: {
            show: true,
          },
          data: data,
        },
        itemStyle: {
          emphasis: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      };
      this.myCharts.setOption(options);
    },
  },
};
</script>

<style scoped lang="scss">
.chartheight{
      height: 300px ;
            @media screen and (max-width: 1400px){
              margin-top: 10px;
          height: 250px;
        }
          @media screen and (max-width: 1340px){
            margin-top: 10px;
          height: 230px;
        }
}
.order_money {
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.06);
  border-radius: 6px;
  overflow: hidden;
  .head {
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 54px;
    padding: 0 24px;
    span {
      color: #2e3458;
      font-size: 16px;
      font-weight: 800;
    }
    img {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    border-bottom: 1px solid #f6f6f6;
  }
  .content {
    height: 306px;
  }
}
</style>
